import { Component, Injector, Input, Inject, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { SeaSearchService } from 'src/app/services/sea/sea-search.service';
import { BaseFormComponentComponent } from 'src/app/shared/base-form-component/base-form-component.component';
import { SeaComponent } from '../sea.component';
import { DatePipe } from '@angular/common';
import { StepperService } from 'src/app/stepper.service';
import { SeaModel } from 'src/app/models/sea/sea-model';
import {SeaPackModel} from "../../../models/sea/sea-pack-model";
import {DecimalPipe} from "../../../shared/decimal.pipe";
import {DocViewerDialogComponent} from "../../../components/doc-viewer-dialog/doc-viewer-dialog.component";
import {DynamicDialogRef} from "primeng/dynamicdialog";
import { ChangeDetectorRef } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';
import { onSelectHistory } from 'src/app/components/search-history/search-history.component';
import { Subscription } from 'rxjs';
import { slowScrollToBottom } from 'src/app/components/search-history/search-history.component';
import { CountryService } from 'src/app/services/country/country.service';
import { CityService } from 'src/app/services/city/city.service';
import { onSelectFixedPrice } from 'src/app/components/dashboard-fixed-prices/dashboard-fixed-prices.component';
import { MinDTO } from 'src/app/models/min-dto';
import { SelectBoxItemModel } from 'src/app/models/select-box-item.model';
import { SseService } from 'src/app/services/sse-service';
import { SeaportMinDTO } from 'src/app/models/seaport-min.dto';

@Component({
  selector: 'app-sea-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [DecimalPipe],
  encapsulation: ViewEncapsulation.None
})
export class SeaSearchComponent extends BaseFormComponentComponent implements OnInit, OnDestroy {

  @Input("model") model: SeaModel;
isCheckboxSelected: boolean = false;
  nowDate = new Date();
  termsDialog: DynamicDialogRef;
    requiredPackFields = [
        {name: 'packing', type: 'string'},
        {name: 'pieces', type: 'number'},
        {name: 'height', type: 'number'},
        {name: 'width', type: 'number'},
        {name: 'lenght', type: 'number'},
        {name: 'perKg', type: 'number'}];
    requiredPackFieldsForT = [
        {name: 'pieces', type: 'number'},
        {name: 'totalVolume', type: 'number'},
        {name: 'totalWeight', type: 'number'}];

    serviceOptions: any[] = [];
    hideToolTip: boolean = false;
    tooltipValue: string | null = null;

    

    historySubscription: Subscription = null; 
    dashboardFixedPriceSubscription: Subscription = null; 
  constructor(protected injector: Injector,private cdr: ChangeDetectorRef, protected userService: UserService,
    @Inject(SeaComponent) public parent: SeaComponent,
    private stepperService: StepperService, private datePipe: DatePipe, private countryService: CountryService,
    private decimalPipe: DecimalPipe, private cityService: CityService, private sseService: SseService,
    private router: Router, private seaSearchService: SeaSearchService) {
    super(injector)
   }

  async ngOnInit(): Promise<void> {


  
    // Tarayıcı geçmişinden (history) veriyi çekiyoruz
    const state = history.state;

 

    const user = await this.userService.user().toPromise();
    this.hideToolTip = user.hideToolTip; 
    this.model.products = null;
    this.model.selectedProduct = null;
    this.model.segment = null;
    this.model.quoteNo = null;
    if(!this.model.packs || this.model?.packs?.length  == 0 ) this.addPack();
    this.model.hasInsurance = false;

    setTimeout(() => this.onChangeInco(false), 1000)
    this.calculateTotals();

    if (!this.model.kp) this.model.kp = 'F';

    /* p-calendar de dışında farklı bir component kullanılacak */
    if(this.model.readinessDate && !(this.model.readinessDate instanceof Date)) {
        this.model.readinessDate = new Date(`${String(this.model.readinessDate).substring(0,10).trim()}`);
    }

    this.parent.stepper.notShowReservation = false;


    if(!this.dashboardFixedPriceSubscription) {
        this.dashboardFixedPriceSubscription = onSelectFixedPrice.subscribe(r => {
            if(r != null)  {
                this.model = r;
                this.parent.model = r;
                this.cdr.detectChanges();
                this.calculateTotals();
            }         
        })
    }
    if(!this.historySubscription) {
        this.historySubscription = onSelectHistory.subscribe(r => {
            slowScrollToBottom(1000);
            const data = JSON.parse(r);
            data.readinessDate = new Date();
            this.isCheckboxSelected = false;

            this.countryService.searchCountry(data.arrivalCountry.name).toPromise().then(c => {
                this.model.arrivalCountry.code = c[0].code;
                const minArrivalPort = new MinDTO();
                minArrivalPort.id = data.arrivalPort.id;
                minArrivalPort.name = `(${data.arrivalCountry?.code}) ${data.arrivalPort?.name} (${data?.arrivalPortCode})`
                this.model.arrivalPort = minArrivalPort;
            })
            
            this.countryService.searchCountry(data.departureCountry.name).toPromise().then(c => {
                this.model.departureCountry.code = c[0].code;
                const minDeparturePort = new SeaportMinDTO();
                minDeparturePort.id = data.departurePort.id;
                minDeparturePort.name = `(${data.departureCountry?.code}) ${data.departurePort?.name} (${data?.departurePortCode})`
                this.model.departurePort = minDeparturePort;
            })
            


            this.model = data;
            this.model.totalVolume = data.totalVolume;
            this.model.totalWeight = data.totalWeight;
            this.model.operationType = (data.kp == 'F' || data.containerType) ? 'FCL': 'LCL';
            this.model.containerCount = data.pieces;
            this.model.segment = null;
            this.parent.model = this.model;
            
            this.calculateTotals()
           
            
        })
    }
  }

  ngOnDestroy(): void {
      if(this.historySubscription) this.historySubscription.unsubscribe();
      if(this.dashboardFixedPriceSubscription) this.dashboardFixedPriceSubscription.unsubscribe();
  }

  getTooltip(key: string): void {
    if (!this.hideToolTip) {

    this.tooltipValue = null;
    setTimeout(() => {
      this.tooltipValue = this.translation.instant(key)
    }, 500);
}
  }
  

    async search(form = null) {

  
        this.model.isOnlinePrice = true;
        const valid = await this.isValid();
        this.model.segment = null;

        if (!valid) return;

        this.validateIncotermMessage();
        if(!this.isValidIncoterm()) return;

    if (this.model.service) {
            if (this.model.service[0] !== 'D') {
                this.model.departureZipTxt = null;
                this.model.departureZip = null;
                this.model.departureAddress = null;
            }


            // Son karakter D değilse arrival zip temizle
            if (this.model.service.slice(-1) !== 'D') {
                this.model.arrivalZipTxt = null;
                this.model.arrivalZip = null;
                this.model.arrivalAddress = null;
            }
        }


        const isEmpty = [];
        let totalWm = null;
        let calculatedPieces = null;

        if (this.model.operationType === 'FCL') {
            this.model.kp = 'F';
            if (!this.model.containerCount || this.model.containerCount <= 0) {
                const pieceWarn = await this.translation.get('piecesWarn').toPromise();
                this.messageService.add({severity: 'warn', key: 'html-msg', summary: '', detail: pieceWarn});
                return;
            }
            if (!this.model.tonnage || this.model.tonnage <= 0) {
                const tonnageWarn = await this.translation.get('tonnageWarn').toPromise();
                this.messageService.add({severity: 'warn', key: 'html-msg', summary: '', detail: tonnageWarn});
                return;
            }
        } else {
            this.model.kp = 'P';
            if (this.model?.td === 'D') {
                this.model.packs.forEach(p => {
                    this.requiredPackFields.map(field => {
                        if (field.type === 'string' && !p[field.name]) {
                            isEmpty.push(field.name);
                        }
                        if (field.type === 'number' && (!p[field.name] || p[field.name] === 0)) {
                            isEmpty.push(field.name);
                        }
                    });
                });

            } else {
                if (!this.model?.totalWeight || this.model?.totalWeight == 0) isEmpty.push('totalWeight');
                if (!this.model?.pieces || this.model?.pieces == 0) isEmpty.push('pieces');
                if (!this.model?.totalVolume || this.model?.totalVolume == 0) isEmpty.push('totalVolume');
            }
            if (isEmpty.length > 0) {
                const fieldsTranslated = [];
                for (let i = 0; i < isEmpty.length; i++) {
                    const val = await this.translation.get(isEmpty[i]).toPromise();
                    fieldsTranslated.push(val);
                }
                const fields = fieldsTranslated.filter((x, i, a) => a.indexOf(x) === i).join('<br/>');
      
                const enterValue = await this.translation.get('enterValues').toPromise();
                this.messageService.add({
                    severity: 'warn',
                    key: 'html-msg',
                    summary: '',
                    detail: enterValue + '<br/>' + fields
                });
                return;
            }
        }

        if(this.model.service[0] == 'D' && this.model.departureCountry?.code == 'HK') this.model.departureZipTxt = '999077'
        if(this.model.service[this.model.service.length -1] == 'D' && this.model.arrivalCountry?.code == 'HK') this.model.arrivalZipTxt = '999077'

        if((this.model.service && this.model.service[0] == 'D' && (!this.model.departurePort.locationSearchForSeaImportPreCarriage && !this.model.departureZip && !this.model.departureZipTxt)) || (this.model.departurePort.locationSearchForSeaImportPreCarriage && !this.model.departureZip && !this.model.departureZipTxt && !this.model.departureCity)) {
            this.showMessage('warn', this.model.departurePort.locationSearchForSeaImportPreCarriage ? 'departureZipOrCityRequired' : 'departureZipRequired');
            return;
        }
        if(this.model.service && this.model.service[this.model.service.length -1] == 'D' && (!this.model.arrivalZip && !this.model.arrivalZipTxt)) {
            this.showMessage('warn', 'arrivalZipRequired');
            return;
        }

        try {
            this.isLoading = true;
            this.parent.productLoading = true;

            /* Todo:
               tarih payload da 1 gün geri gidiyor nedeni anlaşılarak düzeltme uygulanacak.
             */

            // daha önce bulunan ürün varsa siliniyor.
            this.model.products = [];
            totalWm = this.model.totalWm;
            calculatedPieces = this.model.calculatedPieces;
            this.model.id = null;

            localStorage.setItem('search', JSON.stringify(this.model))
            this.scrollToSteps();
            this.parent.container.clear();

             // Eğer mal bedeli 500.000 USD den büyük ise fiyat talep et çıkması için arama yaptırmıyoruz.
            if(this.model.goodPrice < 500000) {
                this.model = await this.seaSearchService.search(this.model).toPromise();
                this.sseService.setReady();
            }


            this.model.totalWm = totalWm;
            this.model.calculatedPieces = calculatedPieces
            this.parent.model = this.model;
            this.parent.productLoading = false;

            
            this.stepperService.changeCurrentStep(2);

            if(!this.parent.showOnlyComponent) {
                this.addQueryParam("page", "FYT")
                this.addQueryParam("op",  this.model.operationType)

                if(this.model.operationType && this.model.operationType == 'FCL') {
                    this.addQueryParam("con",  this.model.containerType.name.replace(' ', ''))
                }
                this.addQueryParam("type", `${this.model.departurePort.name.slice(0,3)}(${this.model.departureCountry.code})-(${this.model.arrivalCountry.code})${this.model.arrivalPort.name.slice(0,3)}`)
            }


        } catch (error){
            this.isLoading = false;
            if (error == 'userBannedForManyRequest'){
                this.forceLogOut();
            }
            this.parent.productLoading = false;
        }

      
        this.isLoading = false

    }

    forceLogOut(){
        Object.keys(localStorage).filter(k => k != 'rememberMe' && k != 'lang' && k != 'uid' && k != 'efl-saved-consent' && k != 'efl-uuid').forEach(key => localStorage.removeItem(key))
        setTimeout(() => {
            this.router.navigate(['/home']);
        }, 4000);
    }

  async getSegment(portFieldName) {
      if (this.model.arrivalPort && this.model.departurePort) {
          if ((this.model.arrivalPort && this.model.departurePort) && this.model.arrivalPort.id == this.model.departurePort.id) {
              setTimeout(() => this.model[portFieldName] = null, 100);
              this.showMessage('warn', 'sameSeaPortWarn');
              return;
          }
      }
      if (this.model.arrivalPort && this.model.departurePort) {
      const segment = await this.seaSearchService.segment(this.model.departurePort.id, this.model.arrivalPort.id, this.model.departureCountry.id, this.model.arrivalCountry.id).toPromise();
      this.model.segment = segment;
      }

      if(this.model.segment) {
        const discounts = await this.seaSearchService.discount(this.model.segment.id).toPromise();
        this.model.discounts = discounts;
      }

  }

  onChangeService() {
    this.model.isPortLoad = false;
    this.model.arrivalAddress = null;
    this.model.arrivalZip = null;
    this.model.departureAddress = null;
    this.model.departureZip = null;

    if (this.model.service) {
        // İlk karakter D değilse departure zip temizle
        if (this.model.service[0] !== 'D') {
        this.model.departureZipTxt = null;
        this.model.departureZip = null;
        }


        // Son karakter D değilse arrival zip temizle
        if (this.model.service.slice(-1) !== 'D') {
        this.model.arrivalZipTxt = null;
        this.model.arrivalZip = null;
        }
    }
  }
  onChangeInco(clearService = true) {
    if(clearService) {
        this.model.service = null;
         this.model.isPortLoad = false;
    }
    
    const serviceTypes = JSON.parse(localStorage.getItem('marketSeaServiceType'));
    switch (this.model.incoterm) {
        case "EXW":
            this.serviceOptions = [ ...serviceTypes.filter(f => ['DTA', 'DTD'].includes(f.code)) ];
            break;
        case "FCA":
            this.serviceOptions = serviceTypes.filter(f => ['ATA', 'ATD'].includes(f.code));
            break;
        case "FOB":
            this.serviceOptions = serviceTypes.filter(f => ['ATA', 'ATD'].includes(f.code));
            break;
        case "FAS":
            this.serviceOptions = serviceTypes.filter(f => ['ATA', 'ATD'].includes(f.code));
            break;
        case "CFR":
            this.serviceOptions = serviceTypes.filter(f => ['DTA', 'ATA'].includes(f.code));
            break;
        case "CIF":
            this.serviceOptions = serviceTypes.filter(f => ['DTA', 'ATA'].includes(f.code));
            break;
        case "CPT":
            this.serviceOptions = serviceTypes.filter(f => ['DTA', 'ATA'].includes(f.code));
            break;
        case "CIP": 
            this.serviceOptions = serviceTypes.filter(f => ['DTA', 'ATA'].includes(f.code));
            break;
        case "DAP": 
            this.serviceOptions = serviceTypes.filter(f => ['DTD', 'ATD'].includes(f.code));
            break;
        case "DDP": 
            this.serviceOptions = serviceTypes.filter(f => ['DTD', 'ATD'].includes(f.code));
            break;
        case "DPU": 
            this.serviceOptions = serviceTypes.filter(f => ['DTD', 'ATD'].includes(f.code));
            break;
        default:
            this.serviceOptions = serviceTypes;
            break;
      }

    
    
  }

    onChangeTD(td: string) {
        this.model.containerType = null;
        this.model.containerCount = 0;
        this.model.td = td;
        this.model.packs = [];
        this.model.packingType = null;
        this.model.pieces = null;
        this.model.tonnage = 0;
        this.model.totalVolume = 0;
        this.model.totalWeight = 0;
        this.model.chargeableVolume = 0;
        this.model.chargeableWeight = 0;
        this.model.totalWm = 0;

        if(td == 'D' ) {
            this.addPack();
        }

        
    }

    async onChangeStackable(event: any) {   
        if (!event.checked) {
             if(this.model.td == 'D' && this.model.operationType == 'LCL') {
                const pieceWarn = await this.translation.get('lclDimenssionMessage').toPromise();
                this.messageService.add({severity: 'warn', key: 'html-msg', summary: '', detail: pieceWarn});
            } 

            if(this.model.packs) {
                this.model.packs.forEach(pack => {
                    pack.height = 265;
                })
                this.calculateTotals();
            }
        } 
    }


    addPack() {

        if(!this.model.packs) this.model.packs = [];
        
        if(!this.model.stackable) {
            const pack = new SeaPackModel();        
            pack.height = 265;
            this.model.packs.push(pack);
            this.calculateTotals();

        } else {
            this.model.packs.push(new SeaPackModel());
        }

    }

    calculateTotals(event:any = null) {
      if (this.model.operationType === 'LCL'){

        if(this.model.td == 'T') {
            this.calculateChargeableWeight();
        }
        if(this.model.td == 'D') {

            if(!this.model.packs) return;
            //calculate total pieces
            this.model.calculatedPieces = 0;
            const pieces = this.model.packs.filter(f => f.pieces).map(f => f.pieces);
            if(pieces.length > 0)  this.model.calculatedPieces = pieces.reduce((a,b) => a + b);

            // calculate total weight
            this.model.totalWeight = 0;
            this.model.packs.forEach(p => {
                this.model.totalWeight +=  (p.pieces * (p.perKg || 0));
            })


            // calculate line volume & calculate line total weight
            this.model.packs.forEach(i => {
                i.totalWeight = (i.perKg || 0) * (i.pieces || 0);
                this.calculateVolume(i);
            })


            // calculate total volume
            this.model.totalVolume = 0;
       
            const volumes = this.model.packs.filter(f => f.lineVolume).map(f => f.lineVolume);
            if(volumes.length > 0)  this.model.totalVolume = volumes.reduce((a,b) => a + b);
            this.model.totalVolume = Number(Number(this.model.totalVolume).toFixed(2));

            this.model.pieces = this.model.calculatedPieces;
            this.calculateChargeableWeight();


            // calculate cwg
        }
      }
    }

    calculateVolume(pack) {
        if (pack.width !== null && pack.height !== null
            && pack.lenght !== null && pack.pieces !== null) {
            let multipiler: number;
            if (!this.model.uselbInch) {
                multipiler = 0.01;
            }else {
                multipiler = 0.0254;
            }
            let height = 0;

            height = pack.height * multipiler;

            const width = pack.width * multipiler;
            const length = pack.lenght * multipiler;
            pack.lineVolume = Number(Number((width * height * length * pack.pieces)).toFixed(2));
        }
    }

    calculateChargeableWeight() {
        if (this.model.totalVolume != null) {
            let calculatedWeight: number;
            calculatedWeight = this.model.totalVolume * 1000;
            if (this.model.totalWeight != null) {
                if (this.model.totalWeight > calculatedWeight) {
                    this.model.chargeableWeight = this.model.totalWeight;
                    this.model.chargeableVolume = this.model.totalWeight / 1000;
                    this.model.totalWm = this.model.chargeableVolume;
                } else {
                    this.model.chargeableWeight = calculatedWeight;
                    this.model.chargeableVolume = calculatedWeight / 1000;
                    this.model.totalWm = this.model.chargeableVolume;
                }
            } else {
                this.model.chargeableWeight = calculatedWeight;
                this.model.chargeableVolume = calculatedWeight / 1000;
                this.model.totalWm = this.model.chargeableVolume;            }

            if(this.model.operationType == 'LCL' && this.model.totalWm < 1){
                 this.model.totalWm = 1;
                 this.model.chargeableVolume = 1;
                 this.model.totalVolume = 1;
            }
        }

    }




    removePack(index: number) {
        this.model.packs.splice(index, 1);
        this.calculateTotals();
    }

    showUseTrms() {
        this.termsDialog = this.dialogService.open(DocViewerDialogComponent, { header: "view", showHeader: false, modal:true, closable: true,  width: '50%', height: '100%',  data: {filePath: `/assets/data/documents/terms_${this.translation.currentLang}.html`}});

    }

    onChangeKp(kp: any) {
    // Model atamaları zaten yapılıyor
    this.model.kp = kp;
    this.model.operationType = (kp === 'F') ? 'FCL' : 'LCL';

    // Formu sıfırlama işlemleri
    this.model.containerType = null;
    this.model.packs = [];
    this.model.packingType = null;
    this.model.pieces = null;
    this.model.containerCount = 0;
    this.model.tonnage = 0;
    this.model.totalVolume = null;
    this.model.totalWeight = null;
    this.model.chargeableVolume = null;
    this.model.chargeableWeight = null;
    this.model.totalWm = null;
    this.model.cwg = 0;
    }

    onSelectZipToAddress(e: any, elementRef: any, zipField = 'departureZip' ){
      if (zipField == 'departureZip') this.model.departureAddress = e.name;
      if (zipField == 'arrivalZip') this.model.arrivalAddress = e.name;
      this.onSelectZip(e, elementRef, zipField);
    }

    onSelectZip(e: any, elementRef: any, zipField = 'departureZip' ) {
      // Eğer diğer seçildi ise postCode boş oluyor.
      if(e.isOptionOther) {
        elementRef.autoComplete.inputEL.nativeElement.value = e.name.trim().split(' ')[0]
        this.model[zipField].name = e.name.trim().split(' ')[0];
        return
      };

      elementRef.autoComplete.inputEL.nativeElement.value = e['postCode']
      this.model[zipField].name = e['postCode']
    }

    onChangeDepartureCountry() {
      this.model.departurePort = null;
      this.model.departureZip = null;
      this.model.departureCity = null;
      this.validateIncotermMessage();

    }
    onChangeArrivalCountry() {
      this.model.arrivalPort = null;
      this.model.arrivalZip = null;
      this.model.arrivalCity = null;
    }

    
    validateIncotermMessage() {
        if(!this.isValidIncoterm()) {
            this.showMessage('warn', 'warningWrongIncotermExport');
            this.model.incoterm = null;
        }
    }
    isValidIncoterm(){
        if(this.model.departureCountry != null && this.model.departureCountry?.code == 'TR' && !['CIF', 'CFR','CPT','CIP', 'DAP', 'DDU', 'DDP'].includes(this.model.incoterm)) {
            return false;
      }
      return true;
    }


    async onSelectDepaturePort(data: any) {

        if(data.cityId && data.cityId != 0) {
          const city =   await this.cityService.getById({cityId: data.cityId}).toPromise();
          if(city) this.model.departureCity = city;
        }
         if(data.countryId && data.countryId != 0) {
          const country =   await this.countryService.getById({countryId: data.countryId}).toPromise();
          if(country) this.model.departureCountry = country;
        }

        this.validateIncotermMessage();
    }
    
    async onSelectArrivalPort(data: any) {

        if(data.cityId && data.cityId != 0) {
          const city =   await this.cityService.getById({cityId: data.cityId}).toPromise();
          if(city) this.model.arrivalCity = city;
        }
         if(data.countryId && data.countryId != 0) {
          const country =   await this.countryService.getById({countryId: data.countryId}).toPromise();
          if(country) this.model.arrivalCountry = country;
        }
    }
    
checkTonnageWarning(value: any) {
    if (value !== null && value !== undefined && value !== '') {
      const tonnageValue = Number(value);
      if (!isNaN(tonnageValue) && tonnageValue > 0 && tonnageValue < 100) {
       this.showMessage('warn', 'tonnageWarning');
      }
    }
  }
  onVolumeInput(event: any) {
    let val = event.target.value;
    val = val.replace(/,/g, '.');
    val = val.replace(/[^0-9.]/g, '');
    const parts = val.split('.');
    if (parts.length > 2) {
      val = parts[0] + '.' + parts.slice(1).join('');
    }

    event.target.value = val;
    this.model.totalVolume = val;
    this.calculateTotals(event);
}

  scrollToSteps() {
    const element = document.querySelector('x-p-steps');  
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  
}
